import { SyntheticEvent, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Grid,
  Input,
  Icon,
  Form,
  Select,
  Dropdown,
  Checkbox,
  Button,
} from 'semantic-ui-react';
import { WorkflowOptions } from '../../../app/models/template';

interface Props {
  index: number;
  setgetkey: any;
  isSelected:boolean;
  // optionsState: WorkflowOptions[];
  handleAddOptionName: any;
  options: WorkflowOptions;
  defaultValue: string;
  setDefaultValueFunction: any;
  getkey: number | null | undefined;
  deleteRow: any;
  openLink: string;
  setOpenLink: any;
  dropdownOptions: any;
  selectedSetting: string;
  getOptionType?: (
    optionId: string,
    optionType: string,
    isMulti?: boolean,
    isDisabled?: boolean,
    isMandatoryColumn?: boolean,
  ) => void;
  handleAddDropdownOptions: (
    _e: SyntheticEvent,
    data: any,
    id: any,
    index: number,
  ) => void;
  handleClear: (id: any, index: number, count: number) => void;
  addOptionRow: (id: any) => void;
}

const columnTypeOptions = [
  {
    key: '0',
    value: 'textBox',
    text: 'Textbox',
  },
  {
    key: '1',
    value: 'number',
    text: 'Number',
  },
  {
    key: '2',
    value: 'datePicker',
    text: 'Date Picker',
  },
  {
    key: '3',
    value: 'dropDown',
    text: 'DropDown',
  },
  {
    key: '4',
    value: 'currentUser',
    text: 'Current User',
  },
  {
    key: '5',
    value: 'textArea',
    text: 'Text Area',
  },
  {
    key: '6',
    value: 'checkBox',
    text: 'Check Box',
  },
];

function WorkflowSettingsOptions({
  index,
  setgetkey,
  // optionsState,
  handleAddOptionName,
  options,
  defaultValue,
  setDefaultValueFunction,    
  getkey,
  deleteRow,
  openLink,
  setOpenLink,
  dropdownOptions,
  selectedSetting,
  getOptionType,
  handleAddDropdownOptions,
  handleClear,
  addOptionRow,
  isSelected
}: Props) {
  const [selectedDynamicTableType, setSelectedDynamicTableType] =
    useState('textBox');
  const [isCheckedMulti, setIsCheckedMulti] = useState(options.isMulti);
  const [isCheckedDisable, setIsCheckedDisable] = useState(options.isDisabled);
  const [isCheckedMandatoryColumn, setIsCheckedMandatoryColumn] = useState(
    options.isSelected,
  );

  const linkValueButton = (options: WorkflowOptions): string[] => {
    let split = options?.optionLinkName?.split('|');
    return split?.[0]?.length ? split : [];
  };

  return (
    <>
      <Grid columns={3} key={index}>
        <Grid.Row>
          <Grid.Column
            width={selectedSetting === 'DynamicTable' ? 6 : 9}
            style={{ alignItems: 'center' }}
          >
            <Grid.Row
              style={{ alignItems: 'center' }}
              onMouseEnter={() => setgetkey(index)}
              onMouseLeave={() => setgetkey(index)}
            >
              <Grid.Column width={10}>
                {selectedSetting === 'DynamicTable' ? (
                  <>
                    {/* {selectedDynamicTableType === "datePicker" ? (
                    <DatePicker
                      value={
                        selectedValue?.length
                          ? selectedValue
                          : new Date().toLocaleDateString("en-IN")
                      }
                      selected={
                        selectedValue?.length
                          ? new Date(
                              `${selectedValue.split("/")[1]}/${
                                selectedValue.split("/")[0]
                              }/${selectedValue.split("/")[2]}`
                            )
                          : new Date()
                      }
                      className={"datePickerComponent"}
                      dateFormat="dd/MM/yyyy"
                      scrollableYearDropdown
                      onChange={(date: any) => {
                        handleAddOptionName("e", date.toLocaleDateString("en-IN"), options.optionId, selectedSetting, selectedDynamicTableType);
                        setSelectedValue(date.toLocaleDateString("en-IN"));
                      }}
                    />
                  ) : ( */}
                    <Input
                      placeholder={'Header Name'}
                      style={{ width: '100%' }}
                      value={options.optionName}
                      onChange={(e: SyntheticEvent, data: any) => {
                        handleAddOptionName(
                          e,
                          data,
                          options.optionId,
                          'DynamicTable',
                          options.optionType || 'textBox',
                        );
                      }}
                    />
                    {/* )} */}
                  </>
                ) : (
                  <>
                    <Input
                      placeholder={'Option'}
                      style={{ width: '100%' }}
                      value={options.optionName}
                      onChange={(e: SyntheticEvent, data: any) => {
                        handleAddOptionName(e, data, options.optionId, 'Input');
                      }}
                    />
                    <Checkbox
                      label="Default Value"
                      onChange={() => setDefaultValueFunction(options)}
                      checked={isSelected}
                    />
                  </>
                )}
                {/* <Icon
                  style={{
                    color: 'black',
                    position: 'absolute',
                    top: '15px',
                    right: 17,
                    cursor: 'pointer',
                  }}
                  onClick={() => deleteRow(options)}
                  size="small"
                  name="close"
                /> */}
              </Grid.Column>
              {options.optionName === defaultValue &&
              selectedSetting !== 'DynamicTable' ? (
                <Grid.Row>
                  {/* <List.Item
                    as="a"
                    onClick={() => setDefaultValueFunction(options)}
                    style={{
                      position: 'absolute',
                      top: '9px',
                      right: 45,
                      textDecoration: 'underline',
                      zIndex: '99',
                      cursor: 'pointer',
                    }}
                  >
                    Default Value
                  </List.Item> */}
                  <Icon
                    style={{
                      color: 'black',
                      position: 'absolute',
                      top: '15px',
                      right: 17,
                      cursor: 'pointer',
                    }}
                    onClick={() => deleteRow(options)}
                    size="small"
                    name="close"
                  />
                </Grid.Row>
              ) : null}
              {(options.optionName !== defaultValue &&
                getkey === index &&
                selectedSetting === 'DropDown') ||
              ((getkey === index && selectedSetting === 'DynamicTable')) ||
              (selectedSetting === 'Checkbox') ? (
                <Grid.Row>
                  {/* {selectedSetting !== 'DynamicTable' ? (
                    <List.Item
                      as="a"
                      onClick={() => setDefaultValueFunction(options)}
                      style={{
                        position: 'absolute',
                        top: '9px',
                        right: 45,
                        textDecoration: 'underline',
                        zIndex: '99',
                        cursor: 'pointer',
                      }}
                    >
                      Set as Default
                    </List.Item>
                  ) : null} */}
                  <Icon
                    style={{
                      color: 'black',
                      position: 'absolute',
                      top: '15px',
                      right: 17,
                      cursor: 'pointer',
                    }}
                    onClick={() => deleteRow(options, selectedSetting)}
                    size="small"
                    name="close"
                  />
                </Grid.Row>
              ) : null}
            </Grid.Row>
          </Grid.Column>
          {selectedSetting === 'DynamicTable' ? (
            <>
              {/* <Grid.Column width={1}>
              <Icon
                style={{
                  color: 'black',
                  marginTop: '10px',
                  left: 0,
                }}
                name="linkify"
                onClick={() => setOpenLink(options.optionId)}
              />
            </Grid.Column> */}
              <Grid.Column width={5}>
                <Dropdown
                  placeholder="Select Type"
                  fluid
                  selection
                  value={options.optionType}
                  search
                  options={columnTypeOptions}
                  onChange={(_e: SyntheticEvent, data: any) => {
                    setSelectedDynamicTableType(data.value);
                    getOptionType?.(options.optionId, data.value, false);
                  }}
                />
              </Grid.Column>
              <Grid.Column width={5} className="align-center">
                {options.optionType === 'dropDown' ||
                selectedDynamicTableType === 'dropDown' ? (
                  <Checkbox
                    name="isMulti"
                    label="Multi Select"
                    onClick={(_e: SyntheticEvent) => {
                      getOptionType &&
                        getOptionType(
                          options.optionId,
                          'dropDown',
                          !isCheckedMulti,
                          undefined,
                        );
                      setIsCheckedMulti(!isCheckedMulti);
                    }}
                    checked={isCheckedMulti}
                  />
                ) : null}
                {options.optionType !== 'currentUser' && (
                  <Checkbox
                    name="isDisableColumn"
                    label="Disable Column"
                    onClick={(_e: SyntheticEvent) => {
                      getOptionType &&
                        getOptionType(
                          options.optionId,
                          options.optionType || 'textBox',
                          undefined,
                          !isCheckedDisable,
                        );
                      setIsCheckedDisable(!isCheckedDisable);
                    }}
                    checked={isCheckedDisable}
                  />
                )}
                {selectedSetting === 'DynamicTable' && (
                  <Checkbox
                    name="isMandatoryColumn"
                    label="Mandatory"
                    onClick={(_e: SyntheticEvent) => {
                      getOptionType &&
                        getOptionType(
                          options.optionId,
                          options.optionType || 'textBox',
                          isCheckedMulti,
                          isCheckedDisable,
                          !isCheckedMandatoryColumn,
                        );
                      setIsCheckedMandatoryColumn(!isCheckedMandatoryColumn);
                    }}
                    checked={isCheckedMandatoryColumn}
                  />
                )}
              </Grid.Column>
            </>
          ) : (
            <>
              <Grid.Column width={1}>
                <Icon
                  style={{
                    color: 'black',
                    marginTop: '10px',
                    left: 0,
                  }}
                  name="linkify"
                  onClick={() => setOpenLink(options.optionId)}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                {/* Show Text Field linked with the option before clicking the settings button */}
                {openLink !== options.optionId &&
                  selectedSetting !== 'DynamicTable' && (
                    <Form.Field
                      style={{ color: 'black', left: 0 }}
                      type="text"
                      control={Input}
                      disabled
                      value={linkValueButton(options)}
                      name="linkify"
                      placeholder={'Select element'}
                      // onClick={() => setOpenLink(options.optionId)}
                    />
                  )}
                {openLink === options.optionId &&
                  selectedSetting !== 'DynamicTable' && (
                    <Form.Field
                      control={Select}
                      placeholder={'Select element'}
                      multiple
                      search
                      options={dropdownOptions}
                      key={index}
                      value={linkValueButton(options)}
                      onChange={(e: SyntheticEvent, data: any) => {
                        handleAddOptionName(
                          e,
                          data,
                          options.optionId,
                          'DropDown',
                        );
                      }}
                    />
                  )}
              </Grid.Column>
            </>
          )}
        </Grid.Row>
      </Grid>
      {(options.optionType === 'dropDown' ||
        selectedDynamicTableType === 'dropDown') && (
        <Grid.Row className="wf-dropdown-options">
          <Grid.Column width={5}>
            <Button
              style={{}}
              onClick={() => addOptionRow(options.optionId)}
              icon="plus"
              positive
              size="small"
              content="Add Options"
            />
          </Grid.Column>
          <Grid.Column width={5}>
            {JSON.parse(options.listOfOptions || '[]').map(
              (dd: string, optIndex: number) => {
                return (
                  <>
                    <Input
                      key={optIndex}
                      placeholder={'Dropdown options'}
                      onChange={(e: SyntheticEvent, data: any) => {
                        handleAddDropdownOptions(
                          e,
                          data,
                          options.optionId,
                          optIndex,
                        );
                      }}
                      value={dd}
                    />
                    <Icon
                      className="clear-option"
                      name={'close'}
                      onClick={() =>
                        handleClear(
                          options.optionId,
                          optIndex,
                          JSON.parse(options.listOfOptions || '[]').length,
                        )
                      }
                    />
                  </>
                );
              },
            )}
          </Grid.Column>
        </Grid.Row>
      )}
    </>
  );
}

export default observer(WorkflowSettingsOptions);
